<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text">{{errorIsFatal?'Fatal':''}} Error Encountered</v-card-title>
        <v-card-text dark>
            <p class='font-weight-dark'>It looks like we've run into an issue. {{errorIsFatal?'Please refresh the page and try again.':''}}</p>
            <p>If this error persists, please contact <a href='mailto:meait@mea.org'>meait@mea.org</a> with the details below:</p>
            <div><strong v-if="errorObject.errorref">REF#{{errorObject.errorref}}</strong> <div v-html="errorObject.errortext"></div></div>
        </v-card-text>
        <v-card-actions v-if="!errorIsFatal">
          <v-spacer></v-spacer>            
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('close-dialog')"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'ErrorDialog',
    props: {
        showDialog: Boolean,
        errorObject:  Object,
        errorIsFatal: Boolean
    }
  }
</script>